// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"823":"453d08c1","899":"fc2fb730"}[chunkId] + ".chunk.js";
};